
import * as PGtvdGxpbj4 from './kotlin-kotlin-stdlib.mjs';
import * as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWlvLWJ5dGVzdHJpbmc_ from './kotlinx-io-kotlinx-io-bytestring.mjs';
import { __ALL_EXPORTS as PGtvdGxpbj4__ALL_EXPORTS } from './kotlin-kotlin-stdlib.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWlvLWJ5dGVzdHJpbmc___ALL_EXPORTS } from './kotlinx-io-kotlinx-io-bytestring.mjs';
import { __TAG as wasmTag, getCachedJsObject } from './kotlin-kotlin-stdlib.mjs'

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const js_code = {
    'kotlinx.io.node.Buffer_$external_prop_getter' : (_this) => _this.Buffer,
    'kotlinx.io.node.BufferObj_$external_fun' : () => new BufferObj(),
    'kotlinx.io.node.allocUnsafe_$external_fun' : (_this, p0) => _this.allocUnsafe(p0),
    'kotlinx.io.node.BufferObj_$external_object_getInstance' : () => BufferObj,
    'kotlinx.io.node.BufferObj_$external_class_instanceof' : (x) => x instanceof BufferObj,
    'kotlinx.io.node.BufferObj_$external_class_get' : () => BufferObj,
    'kotlinx.io.node.length_$external_prop_getter' : (_this) => _this.length,
    'kotlinx.io.node.readInt8_$external_fun' : (_this, p0) => _this.readInt8(p0),
    'kotlinx.io.node.writeInt8_$external_fun' : (_this, p0, p1) => _this.writeInt8(p0, p1),
    'kotlinx.io.node.existsSync_$external_fun' : (_this, p0) => _this.existsSync(p0),
    'kotlinx.io.node.mkdirSync_$external_fun' : (_this, p0) => _this.mkdirSync(p0),
    'kotlinx.io.node.renameSync_$external_fun' : (_this, p0, p1) => _this.renameSync(p0, p1),
    'kotlinx.io.node.rmdirSync_$external_fun' : (_this, p0) => _this.rmdirSync(p0),
    'kotlinx.io.node.rmSync_$external_fun' : (_this, p0) => _this.rmSync(p0),
    'kotlinx.io.node.statSync_$external_fun' : (_this, p0) => _this.statSync(p0),
    'kotlinx.io.node.openSync_$external_fun' : (_this, p0, p1) => _this.openSync(p0, p1),
    'kotlinx.io.node.closeSync_$external_fun' : (_this, p0) => _this.closeSync(p0),
    'kotlinx.io.node.readFileSync_$external_fun' : (_this, p0, p1) => _this.readFileSync(p0, p1),
    'kotlinx.io.node.writeFileSync_$external_fun' : (_this, p0, p1) => _this.writeFileSync(p0, p1),
    'kotlinx.io.node.opendirSync_$external_fun' : (_this, p0) => _this.opendirSync(p0),
    'kotlinx.io.node.realpathSync_$external_prop_getter' : (_this) => _this.realpathSync,
    'kotlinx.io.node.constants_$external_prop_getter' : (_this) => _this.constants,
    'kotlinx.io.node.mode_$external_prop_getter' : (_this) => _this.mode,
    'kotlinx.io.node.size_$external_prop_getter' : (_this) => _this.size,
    'kotlinx.io.node.isDirectory_$external_fun' : (_this, ) => _this.isDirectory(),
    'kotlinx.io.node.S_IFREG_$external_prop_getter' : (_this) => _this.S_IFREG,
    'kotlinx.io.node.S_IFDIR_$external_prop_getter' : (_this) => _this.S_IFDIR,
    'kotlinx.io.node.S_IFMT_$external_prop_getter' : (_this) => _this.S_IFMT,
    'kotlinx.io.node.native_$external_fun' : (_this, p0) => _this.native(p0),
    'kotlinx.io.node.closeSync_$external_fun_1' : (_this, ) => _this.closeSync(),
    'kotlinx.io.node.readSync_$external_fun' : (_this, ) => _this.readSync(),
    'kotlinx.io.node.name_$external_prop_getter' : (_this) => _this.name,
    'kotlinx.io.node.tmpdir_$external_fun' : (_this, ) => _this.tmpdir(),
    'kotlinx.io.node.platform_$external_fun' : (_this, ) => _this.platform(),
    'kotlinx.io.node.EOL_$external_prop_getter' : (_this) => _this.EOL,
    'kotlinx.io.node.isAbsolute_$external_fun' : (_this, p0) => _this.isAbsolute(p0),
    'kotlinx.io.node.dirname_$external_fun' : (_this, p0) => _this.dirname(p0),
    'kotlinx.io.node.basename_$external_fun' : (_this, p0) => _this.basename(p0),
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.catchJsThrowable' : (block) => {
        try {
            block();
            return null;
        } catch (e) {
            if (e.message) return e.message;
            if (e && e.toString) return e.toString();
            return e + "";
        }
    },
    'kotlinx.io.__convertKotlinClosureToJsClosure_0' : (f, trampoline) => getCachedJsObject(f, () => trampoline(f, )),
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.persistModule' : 
        (globalThis.module = (typeof process !== 'undefined') && (process.release.name === 'node') ?
            await import(/* webpackIgnore: true */'node:module') : void 0, () => {})
    ,
    'kotlinx.io.node.getRequire' : () => { 
        const importMeta = import.meta;
        return globalThis.module.default.createRequire(importMeta.url);
    }
    ,
    'kotlinx.io.node.requireModule' : 
        (require, mod) => {
             try {
                 let m = require(mod);
                 if (m) return m;
                 return null;
             } catch (e) {
                 return null;
             }
        }

}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export const importObject = {
    js_code,
    intrinsics: {

        tag: wasmTag
    },
    "'": StringConstantsProxy,
    '<kotlin>': PGtvdGxpbj4__ALL_EXPORTS,
    '<org.jetbrains.kotlinx:kotlinx-io-bytestring>': PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWlvLWJ5dGVzdHJpbmc___ALL_EXPORTS,
};
    